import type { AnnotationLabelT } from '../../../common/types/types';
import type { AnnotationStoreT } from '../../labelling/types';
import type { AnnotationFramesRecord, AnnotationMetadataRecord } from '../types/annotation';
import { buildAnnotationForOutput } from './build-annotation-for-output';
type OutputFrameT = {
  annotationStore: AnnotationStoreT;
  imageUrl: string;
};
type PropsT = {
  frameCount: number;
  loadedFrames: AnnotationFramesRecord;
  annotationMetadata: AnnotationMetadataRecord;
  annotationLabels: AnnotationLabelT[];
  frameImageUrls: string[];
};
export function buildOutputFrames({
  frameCount,
  loadedFrames,
  annotationMetadata,
  annotationLabels,
  frameImageUrls
}: PropsT): OutputFrameT[] {
  return Array.from({
    length: frameCount
  }, (_, frameIndex) => {
    const frameMap = loadedFrames.get(frameIndex) ?? new Map();
    const annotationStore: AnnotationStoreT = {};
    for (const [annotationId, payload] of frameMap) {
      const metadata = annotationMetadata.get(annotationId);
      if (metadata) {
        annotationStore[annotationId] = buildAnnotationForOutput(payload, metadata, annotationLabels, frameIndex);
      }
    }
    return {
      annotationStore,
      imageUrl: frameImageUrls[frameIndex] ?? ''
    };
  });
}